export default __webpack_public_path__ + "static/media/Frames-mini.005c7778.jpg";